import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchDirectionOUComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getAllDirectionsOUCombo from '../../services/directionUO/getAllDirectionsOUCombo'

export function * fetchDirectionOUCombo () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const directions = yield call(getAllDirectionsOUCombo, auth.token)
    yield put(fetchDirectionOUComboSuccess(directions))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchDirectionOUCombo () {
  yield takeLatest(combosActionTypes.FETCH_DIRECTIION_OU_COMBO, fetchDirectionOUCombo)
}
